import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { Event } from '../interfaces/event';
import { AuthService } from './auth.service';

const RESTRICTED_EVENT_IDS = [4];

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private https: HttpClient, private authService: AuthService) { }

  private isAdmin(): boolean {
    return this.authService.getUser()?.roleId === 2;
  }

  getEvents() {
    return this.https.get<Event[]>(environment.apiUrl + 'events/future').pipe(
      map(events => {
        if (this.isAdmin()) return events;
        return events.filter(e => !RESTRICTED_EVENT_IDS.includes(e.id));
      })
    );
  }

  getEvent(slug: string) {
    return this.https.get<Event>(`${environment.apiUrl}events/user/${slug}`);
  }
}
